export function roundUpTo(n: number, digits: number): string {
	if (n % 1 != 0) return n.toFixed(digits);

	return n.toString();
}
